import axios from "axios";
import { getSessionId } from "../../../utils/tokenHandlers";

export const logoutConCurrrentLogin = (userId: number) => {
  const sessionId = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}user/clear_all_sessions`,
      {
        params: {
          f_uid: userId,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      //  // console.log("in api bro-->", guest_user_arn);
      //  // console.log("api response-->", response);
      return response;
    })
    .catch((err) => err);
};
